import { ElementRef, Injectable } from '@angular/core';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { BehaviorSubject } from 'rxjs';

export interface AppFocusArea {
  element: HTMLElement;
  label: string;
  focusCallback?: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class AdornmentsService {
  private _header: HeaderComponent;
  private _footer: FooterComponent;

  focusAreas = new BehaviorSubject<AppFocusArea[]>([]);

  public registerHeader(header: HeaderComponent) {
    this._header = header;
  }

  public registerFooter(footer: FooterComponent) {
    this._footer = footer;
  }

  public setHeaderTo(element: ElementRef<any>) {
    if (!this._header) return;
    this._header.replaceHeader(element);
  }

  public removeHeader(element: ElementRef<any>) {
    if (!this._header) return;
    this._header.removeHeader(element);
  }

  public hideFooter() {
    this._footer.hidden = true;
  }

  public showFooter() {
    this._footer.hidden = false;
  }

  public registerFocusArea(element: HTMLElement, label: string, focusCallback?: () => void) {
    this.focusAreas.next([...this.focusAreas.value, { element, label, focusCallback }]);
  }

  public unregisterFocusArea(element: HTMLElement) {
    this.focusAreas.next(this.focusAreas.value.filter((area) => area.element !== element));
  }

}
